<form class="search-field" [formGroup]="searchForm" (ngSubmit)="onSubmit()">
  <mat-form-field appearance="fill" class="field-round search-field search-field__field" [subscriptSizing]="'dynamic'">
    <fstr-icon class="ms-3 me-2 text-secondary" matPrefix anchor="line-icon-search"></fstr-icon>

    <input #input matInput [placeholder]="'zoekveld-placeholder' | fromDictionary" formControlName="query" autofocus />

    <!--<span matSuffix class="text-dark me-3">TODO: select</span>-->
  </mat-form-field>
  <button class="button button--accent search-field__button" type="submit">
    <span>Zoeken</span>
  </button>
</form>

<!--<pre>Zoekopracht: {{ query.value }}</pre>
<pre>initialQuery: {{ initialQuery() }}</pre>-->
